import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import resume from '../Media/resume/TLewis_CV.pdf'

/*
import AGN_Wallpaper from '../Media/AGN_Wallpaper.jpg'

import CustomPicture from './CustomPicture'

const agnSteps = [{
    label: 'AGN Wallpaper',
    imgPath: AGN_Wallpaper,
}];
*/
class Projects extends React.Component {

    render() {
        return (
            <div className='home'>

                <h2>Research Experiences</h2>
                
                <p>
                My theoretical work on active galactic nuclei contributes to our understanding of astrophysical jet energetics near compact objects.  As a theorist, I think it is important that astrophysical theories be grounded in observations. My analytic and numeric models are efficient and intuitive. I am particularly interested in particle acceleration processes and the balance of energetics as a probe of the disk-jet connection. More recently, I have been working with leptohadronic models to examine the neutrino spectra of TXS 0506+056 and the potential for other multimessenger blazars.
                </p>
                <p>
                My primary focus is on one-zone particle transport models of blazar jet emission regions.  I found analytical solutions to these transport equations, where analytic solutions exist.  I authored a numerical routine for an equation with no analytic solution, developing a new mathematical technique, where the standard method fails.  This careful and emission-consistent treatment of the particle distribution enabled tracking of particle acceleration processes and energetics, which are important open questions in astrophysics.  I made careful calculations of multi-wavelength blazar spectra including more AGN components individually and Fourier-dependent X-ray time lags to compare with blazar data.  This body of work advanced our understanding of acceleration and emission mechanisms in blazars, as they relate to the particles in the emitting region. 
                </p>
                <p>
 As an undergraduate, I performed time-series analysis of cataclysmic variables from Kepler data.  My experience with Kepler data helped me to contribute to the early exoplanet research at the GMU Observatory.  Throughout my graduate career, I lead optical observations of exoplanet candidates through both transit and microlensing methods.  My postdoctoral work expanded into narrow band reverberation mapping of optical (radio-quiet) AGN continua to look for intra-band time lags indicative of the inner broad line region/outer accretion disk size.  I have also observed radio-loud quasars similarly to test the methodology, and which in conjunction, will provide an observational accretion disk size distribution with respect to black hole mass.  I developed a simulation for radiative driven outflows in quasars to duplicate the observed phenomenon of stable C IV line-locking, which is currently unexplained by theory.  This work gives limits on AGN outflow structure, metallicity, and kinematics, for the statistically significant number of systems in which line-locking is observed.
                 </p>
<p>
An outline of my research interests is included in my CV. 
</p>

<Button href={resume} target="_blank">Curriculum Vitae</Button>
            

            </div>
        );
    }
}

const styles = theme => ({
  root: {
    maxWidth: 400,
    flexGrow: 1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    paddingLeft: theme.spacing.unit * 4,
    backgroundColor: theme.palette.background.default,
  },
  img: {
    display: 'block',
    overflow: 'hidden',
    width: '100%',
  },
});

Projects.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Projects);



// WEBPACK FOOTER //
// ./src/Components/Research.js